export const ROLE_VALUE = {
  specialist: "specialist",
  requester: "requester",
};

const LEGACY_TO_CANONICAL = {
  expert: ROLE_VALUE.specialist,
  helper: ROLE_VALUE.specialist,
  client: ROLE_VALUE.requester,
  specialist: ROLE_VALUE.specialist,
  requester: ROLE_VALUE.requester,
};

export const ROLE_LABELS = {
  [ROLE_VALUE.specialist]: "Expert",
  [ROLE_VALUE.requester]: "Customer",
  // legacy keys for safety
  expert: "Expert",
  helper: "Expert",
  client: "Customer",
};

export const ROLE_LABELS_PLURAL = {
  [ROLE_VALUE.specialist]: "Experts",
  [ROLE_VALUE.requester]: "Customers",
  // legacy keys for safety
  expert: "Experts",
  helper: "Experts",
  client: "Customers",
};

export function normalizeRole(role) {
  if (!role) return null;
  const key = String(role).toLowerCase().trim();
  return LEGACY_TO_CANONICAL[key] || key;
}

export function isSpecialist(role) {
  return normalizeRole(role) === ROLE_VALUE.specialist;
}

export function isRequester(role) {
  return normalizeRole(role) === ROLE_VALUE.requester;
}

export function getRoleLabel(role) {
  const canonical = normalizeRole(role);
  if (!canonical) return "User";
  return ROLE_LABELS[canonical] || canonical;
}

export function getRoleLabelPlural(role) {
  const canonical = normalizeRole(role);
  if (!canonical) return "Users";
  return ROLE_LABELS_PLURAL[canonical] || `${getRoleLabel(canonical)}s`;
}

